import { jsx } from "react/jsx-runtime";
import { Overlay } from "../Overlay/Overlay.mjs";
const boxShadowForVariant = {
  default: "borderField",
  disabled: "borderNeutralLight",
  formAccent: "borderFormAccent",
  critical: "borderCritical"
};
const FieldOverlay = ({ variant, ...restProps }) => /* @__PURE__ */ jsx(
  Overlay,
  {
    component: "span",
    borderRadius: "standard",
    boxShadow: boxShadowForVariant[variant],
    transition: "fast",
    ...restProps
  }
);
export {
  FieldOverlay
};
